import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import PreferredStar from '../PreferredStar';
import { CyclingLabel } from './styles';
import IconFont from '../../components/shared/IconFont';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import { MatchRowWrapper, MatchStatsWrapper } from './styles';
//import * as status from '../../constants';


const CyclingRow = ({ matchRow, showRowScorer, actions, dictionary, isMobile, date, sportId, isHighlight, competition }) => {

  const nomeTappa = matchRow.get('tappa').get('nome');
  const partenza = matchRow.get('tappa').get('partenza_cb').get('citta');
  const arrivo = matchRow.get('tappa').get('arrivo_cb').get('citta');

  const handleFavourites = () => {
    if (!showRowScorer) {
      if (!LocalStorageUtility.isPreferred(matchRow.get('matchId'))) {
        actions.showTooltip();
        setTimeout(() => {
          actions.hideTooltip();
        }, 2500);
      }
      actions.favouriteGame(sportId, matchRow.get('matchId'));
      actions.setFavouritesOnCompetition(matchRow.get('matchId'));
    } else {
      actions.removefavouriteGame(sportId, matchRow.get('matchId'), date);
    }
  };

  const isLive = () =>  matchRow.get('status') && matchRow.get('status') === 'INPROGRESS';

  const getLabel = () => {
    return `${competition.get('competitionName')} ${nomeTappa}: ${partenza} - ${arrivo}`;
  };

  const getContentLabel = () => {
    if (isLive()) {
      return 'Live';
    } else if (matchRow.get('status') && matchRow.get('status') === 'COMPLETE') {
      return 'Terminata';
    } else {
      return matchRow.get('tappa').get('orario_partenza');
    }
  };

  return (
    <MatchRowWrapper
      isHighlight
      href={matchRow.get('permalink')}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          md={1}
          sm={1}
          xs={1}
          style={{
            top: isMobile ? '-15px' : '',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
          }}
          onClick={event => event.preventDefault()}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={matchRow.get('favourite')} />
        </Col>
        {isMobile &&
          <Col sm={5.7} xs={5.7} style={{ paddingRight: 0 }}>
            <CyclingLabel
              color={isLive() ? 'liveColor' : 'black'}
              marginLeft={0.5}
              font="narrowMedium"
            >
            {getLabel()}
            </CyclingLabel>
          </Col>
        }
        {!isMobile &&
          <Col md={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <CyclingLabel
              color={isLive() ? 'liveColor' : 'black'}
              marginLeft={0.5}
              font="narrowMedium"
            >
            {getLabel()}
            </CyclingLabel>
          </Col>
        }
        <Col md={3} sm={2} xs={2} style={{ paddingRight: 0, paddingLeft: isMobile ? '0px' : '15px' }}>
          <CyclingLabel
              color={isLive() ? 'liveColor' : 'black'}
              marginLeft={0.5}
              font="narrowMedium">
            {getContentLabel()}
          </CyclingLabel>
        </Col>
        <Col lg={1} md={1.8} sm={1.8} xs={1.5} style={{
            display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: isMobile ? '10px' : '10px', paddingLeft: isMobile ? '0' : '15px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
    </MatchRowWrapper>
  );
};

CyclingRow.propTypes = {
  matchRow: PropTypes.any,
  showRowScorer: PropTypes.any,
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  date: PropTypes.string,
  sportId: PropTypes.any,
  isHighlight: PropTypes.bool,
  competitionId: PropTypes.any,
};

export default CyclingRow;
